import { View, Text } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import styles from '../common/styles';
import { ContactDTO } from '@behavior/inventories/dto/ContactDTO';

type Props = {
  width: number;
  distributionList: ContactDTO[];
};

export const DistributionListTable = ({ width, distributionList }: Props) => {
  const { t } = useTranslation();

  return (
    <View style={[styles.thinRoundBorder]}>
      <View style={styles.accordianSubTitle}>
        <Text>{t('traceability.form.details.page.container.distribution.list')}</Text>
      </View>
      <View style={styles.table}>
        <View style={styles.tableRow}>
          <View style={[{ width: width }, styles.bold]}>
            <Text>{t('traceability.form.details.page.container.person.name')}</Text>
          </View>
          <View style={[{ width: width }, styles.bold]}>
            <Text>{t('traceability.form.details.page.container.person.email')}</Text>
          </View>
          <View style={[{ width: width }, styles.bold]}>
            <Text>{t('traceability.form.details.page.container.person.role')}</Text>
          </View>
        </View>
        {distributionList.map(contact => {
          return (
            <View style={styles.tableRow}>
              <View style={[{ width: width }]}>
                <Text>{contact.person?.firstName + ' ' + contact.person?.lastName}</Text>
              </View>
              <View style={[{ width: width }]}>
                <Text>{contact.person.email}</Text>
              </View>
              <View style={[{ width: width }]}>
                <Text>{contact.role && contact.role.length > 0 ? contact.role : '-'}</Text>
              </View>
            </View>
          );
        })}
      </View>
    </View>
  );
};
